export const locale = {
  lang: 'es',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'SHEDULE': {
      'TITLE1': 'Registrar fecha de lanzamiento: ',
      'TITLE2': 'Registrar recordatorio: ',
      'TITLE3': 'Registrar cierre: ',
      'ERR01':'Los recordatorios no pueden ser menor a la fecha de lazamiento',
      'ERR02':'Los recordatorios no pueden ser mayor a la fecha de cierre',
      'ERR03':'Los recordatorios deben ser durante los 21 días de la encuesta',
      'ERR04':'Solo puedes tener 3 recordatorios',
      'ERR05':'La fecha no puede ser menor a la actual',
      'ERR06':'Ya has enviado un correo el día de hoy',
      'SUC01':'Recordatorio registrado',
      'SELECT_DATE': 'Seleccione una fecha: ',
      'SAVE': 'Guardar',
      'RECORDATORIOS': 'Recordatorios',
      'RECORDATORIO': 'Recordatorio',
      'ERRORDATE':'La fecha no puede ser menor a la actual.',
      'SAMEDATE':'No está permitido elegir la fecha actual como fecha de lanzamiento de la encuesta',

      'LESSDAYS_T':'¿Seguro que desea continuar?',
      'LESSDAYS_I':'Para que los colaboradores reciban el plan de comunicación completo, es necesario que programe la encuesta con al menos 15 días de anticipación.',
      'CONFLDATE_T':'¡Advertencia!',
      'CONFLDATE_I':'Si continúa no podrá revertir la fecha de lanzamiento. ',

      'FECHA': 'Fecha: ',
      'AGREGAR': 'Agregar',
      'EDITAR': 'Editar',
      'COMPLETAR_PASO': 'Completar paso',
      'PASO_COMPLETADO': 'Paso completado',
      'SUBIRLOGO': 'Para crear su encuesta es necesario subir su logo de empresa',
      'ACEPTARREQUERIMIENTOS': 'Para crear su encuesta es necesario aceptar los requerimientos técnicos',

      'SELECCIONE_FECHA': 'Por favor, seleccione una fecha',
      'DATE_REGISTERED': 'Fecha de lanzamiento registrada correctamente',
      'CLOSE_REGISTERED': 'Fecha de cierre registrada con éxito',
      'CLOSE_MSJ1': 'la fecha de cierre debe ser mayor que la fecha de lanzamiento',
      'CLOSE_MSJ2': 'Antes de cerrar, debe registrar la fecha de lanzamiento',
      'REMIDEROK': 'Recordatorio registrado correctamente',
      'REMIDER_MSJ1': 'el recordatorio debe ser mayor que la fecha de lanzamiento',
      'REMIDER_MSJ2': 'Antes de registrar un recordatorio, debe registrar la fecha de lanzamiento',
      'ESPERA_ENCUESTA': 'Espere, esto puede tomar unos minutos',
      'ENCUESTA': 'Encuesta',
      'CREANDO_ENCUESTA': 'Creando Encuesta...',
      'AGREGANDO_USUARIOS': 'Agregando usuarios...',
      'AGREGANDO_SECCION1': 'Agregando NPS a la encuesta...',
      'AGREGANDO_SECCION2': 'Agregando REACTIVOS a la encuesta...',
      'AGREGANDO_SECCION3': 'Agregando CONTROL a la encuesta...',
      'AGREGANDO_SECCION4': 'Agregando DEMOGRAFICOS a la encuesta...',
      'AGREGANDO_SECCION5': 'Agregando ADICIONALES a la encuesta...',
      'AGREGANDO_SECCION6': 'Agregando PRACTICAS CULTURALES a la encuesta...',
      'AGREGANDO_SECCION7': 'Agregando Preguntas abiertas a la encuesta...',
      'REINTENTAR': 'Reintentar',
      'ERROR_ENCUESTA': 'Error al crear la encuesta',
      'ERROR_USUARIOS': 'Error al agregar usuarios...',
      'ERROR_SECCION1': 'Error al agregar NPS a la encuesta...',
      'ERROR_SECCION2': 'Error al agregar REACTIVOS a la encuesta...',
      'ERROR_SECCION3': 'Error al agregar CONTROL a la encuesta...',
      'ERROR_SECCION4': 'Error al agregar DEMOGRAFICOS a la encuesta...',
      'ERROR_SECCION5': 'Error al agregar ADICIONALES a la encuesta...',
      'ERROR_SECCION6': 'Error al agregar PRACTICAS CULTURALES a la encuesta...',
      'ERROR_SECCION7': 'Error al agregar Preguntas abiertas a la encuesta...',

      'SUCCESS_ENCUESTA': '¡Encuesta creada correctamente!',
      'SUCCESS_USUARIOS': '¡Usuarios agregados correctamente!',
      'SUCCESS_SECCION1': '¡NPS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION2': '¡REACTIVOS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION3': '¡PREGUNTA DE CONTROL agregada correctamente a la encuesta!',
      'SUCCESS_SECCION4': '¡DEMOGRÁFICOS agregados correctamente a la encuesta!',
      'SUCCESS_SECCION5': '¡ADICIONALES agregados correctamente a la encuesta!',
      'SUCCESS_SECCION6': '¡PRÁCTICAS CULTURALES agregadas correctamente a la encuesta!',
      'SUCCESS_SECCION7': 'PREGUNTAS ABIERTAS agregadas correctamente a la encuesta!',
      'BTN_CREARENCUESTA': 'Crear encuesta',

      'CONTINUE_FINISH': 'Encuesta creada correctamente, finalice el paso',
      'LAUNCH_SURVEY': 'Por favor, cree la encuenta para poder finalizar el paso',
      'PULSE':{
        //Shedule survey
        'MES1': ' Pulse Check mes 1',
        'MES2': ' Pulse Check mes 2',
        'MES3': ' Pulse Check mes 3',
        'MES4': ' Pulse Check mes 4',
        'MES5': ' Pulse Check mes 5',
        'MES6': ' Pulse Check mes 6',
        'MES7': ' Pulse Check mes 7',
        'MES8': ' Pulse Check mes 8',
        'MES9': ' Pulse Check mes 9',
        'MES10': ' Pulse Check mes 10',
        'MES11': ' Pulse Check mes 11',
        'MES12': ' Pulse Check mes 12',
        'INDICA': 'Selecciona la fecha de pulse check',
        'INDICA_GENERA':'Generar Encuesta',
        'SUBINDICA_GENERA':'De clic para generar encuesta',


      },
    },
  }
};
